import { connect } from 'react-redux';
import { compose } from 'redux';
import Image from '../components/Image';
import onlyIf from '../hocs/onlyIf';
import { getOverlayHeaderProps } from '../selectors/fixedArea';
function mapStateToProps(state, _a) {
    var screenID = _a.screenID, width = _a.width, height = _a.height, isCurrentScreen = _a.isCurrentScreen;
    return getOverlayHeaderProps(state, screenID, width, height, isCurrentScreen);
}
var exists = function (_a) {
    var header = _a.header;
    return !!header;
};
export default compose(connect(mapStateToProps), onlyIf(exists))(Image);
